import Vue from 'vue';

const success = (response, context) => {
  context.loading = false;
  context.paymentDisabled = false;
  toastr.success(response.data.msg);
};

const failed = (error, context) => {
  context.loading = false;
  context.paymentDisabled = false;
  context.showSecureIframe = false;

  if (error && error.response && error.response.data && error.response.data.reason) {
    toastr.error(context.$t('payments.error.card_declined'));
    context.error = context.$t('payments.error.card_declined');
  } else {
    context.error = error;
    context.showToasterError(error);
  }
};

export default (context, data) => {
  return Vue.$http.post('/create-stripe-customer', data)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    }).catch((error) => {
      if (error) {
        failed(error, context);
      }
    });
};



// WEBPACK FOOTER //
// ./src/app/services/card-connect/createStripeCustomer.js